import { Form, FormInstance, InputNumber, Switch } from '@pankod/refine-antd'
import React from 'react'

type SelfEnrollmentBasicConfigFormFieldsProps = {
  form: FormInstance
}

const SelfEnrollmentBasicConfigFormFields = ({
  form,
}: SelfEnrollmentBasicConfigFormFieldsProps) => {
  const quotaMaxProgram = Form.useWatch('quotaMaxProgram', form)

  return (
    <>
      <Form.Item
        name="quotaMaxProgram"
        label="Kuota Maksimum Program"
        rules={[
          {
            required: true,
            message: 'Kuota maksimum program wajib diisi',
          },
          {
            type: 'number',
            min: 1,
            message: 'Kuota maksimum program minimal 1',
          },
        ]}
      >
        <InputNumber
          className="!w-full"
          min={1}
          precision={0}
          placeholder="Masukkan kuota maksimum program"
        />
      </Form.Item>

      <Form.Item
        name="quotaMaxKelas"
        label="Kuota Maksimum Kelas"
        dependencies={['quotaMaxProgram']}
        rules={[
          {
            required: true,
            message: 'Kuota maksimum kelas wajib diisi',
          },
          {
            type: 'number',
            min: 1,
            message: 'Kuota maksimum kelas minimal 1',
          },
          {
            validator: (_, value: number | undefined) => {
              if (typeof value !== 'number') {
                return Promise.resolve()
              }

              if (
                typeof quotaMaxProgram === 'number' &&
                value > quotaMaxProgram
              ) {
                return Promise.reject(
                  new Error(
                    'Kuota maksimum kelas tidak boleh lebih besar dari kuota maksimum program',
                  ),
                )
              }

              return Promise.resolve()
            },
          },
        ]}
      >
        <InputNumber
          className="!w-full"
          min={1}
          max={
            typeof quotaMaxProgram === 'number' ? quotaMaxProgram : undefined
          }
          precision={0}
          placeholder="Masukkan kuota maksimum kelas"
        />
      </Form.Item>

      <Form.Item
        name="isAutoApprove"
        label="Aktifkan Auto-approve"
        valuePropName="checked"
        rules={[{ required: true, message: 'Status auto-approve wajib diisi' }]}
      >
        <Switch />
      </Form.Item>
    </>
  )
}

export default SelfEnrollmentBasicConfigFormFields
